import Vue from 'vue'
import utils from './common.js'
// 200 => success
// 200以外 => error
const get = (url, params) => {
  var initOptions = {
    xhr: {
      withCredentials: true,
    },
    timeout:10000,
  }
  params && Object.assign(initOptions, {params})
  return new Promise((resolve, reject) => {
    Vue.http.get(url, initOptions)
      .then(res => {
        resolve(res.body)
      }, rej => {
        if(rej.type==='repeat'){
          reject('repeat')
        }else{
          reject(rej.body)
        }
      })
  })
}

const post = (url, options) => {
  var initOptions = {
    timeout:10000,
    xhr: {
      withCredentials: true,
    },
    headers: {
      'X-CSRFToken': utils.getCookie('csrftoken')
    }
  }
  return new Promise((resolve, reject) => {
    Vue.http.post(url, options, initOptions)
    .then(res => {
      resolve(res.body)
    }, rej => {
      if(rej.type==='repeat'){
        reject('repeat')
      }else{
        reject(rej.body)
      }
    })
  })
}

export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/utils/request.js